import React, {Fragment} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";

import {Colors, Container, Text, Button} from "@bounce/shared/ui";
import {sessionDataHandler} from "../sessionDataHandler";
import {changeEngagementPhase, updatePreEngagementData, setPreEngagementMessages} from "../store/actions/genericActions";
import {EngagementPhase, AppState} from "../store/definitions";
import type {Transcript} from "./Transcript";

export const ConversationEnded = () => {
  const dispatch = useDispatch();
  const {messages, users, preEngagementData, transcriptConfig} = useSelector(
    (state: AppState) => ({
      messages: state.chat.messages,
      users: state.chat.users,
      // @ts-expect-error Conversation attributes type is not properly defined
      preEngagementData: state.chat.conversation?.attributes?.pre_engagement_data,
      transcriptConfig: state.config.transcript,
    }),
    shallowEqual
  );

  const handleStartNewChat = () => {
    sessionDataHandler.clear();
    dispatch(updatePreEngagementData({email: "", name: "", query: ""}));
    dispatch(setPreEngagementMessages([]));
    dispatch(changeEngagementPhase({phase: EngagementPhase.PreEngagementChat}));
  };

  let TranscriptComponent: typeof Transcript | undefined = undefined;

  // This file and its related dependencies are only bundled if transcripts are enabled in .env file
  if (
    import.meta.env.VITE_DOWNLOAD_TRANSCRIPT_ENABLED === "true" ||
    import.meta.env.VITE_EMAIL_TRANSCRIPT_ENABLED === "true"
  ) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    ({Transcript: TranscriptComponent} = require("./Transcript"));
  }

  return (
    <Container
      sx={{
        p: "24px",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: Colors.bw.white,
        textAlign: "center",
      }}
    >
      <Text size={16} fontWeight={600}>
        Thanks for chatting with us!
      </Text>
      {TranscriptComponent ? (
        <TranscriptComponent
          messages={messages}
          preEngagementData={preEngagementData}
          users={users}
          transcriptConfig={transcriptConfig}
        />
      ) : (
        <Fragment />
      )}
      <Text size={14} fontWeight={400} sx={{my: "16px"}}>
        If you have any more questions, feel free to reach out again.
      </Text>
      <Button
        onClick={handleStartNewChat}
      >
        Start new chat
      </Button>
    </Container>
  );
};
